import { useEffect } from 'react'

// Locks body scroll while `locked` is true (mobile menus, bottom sheets).
// Toggles the `.no-scroll` class defined in styles/globals.css.
const useBodyScrollLock = (locked) => {
  useEffect(() => {
    document.body.classList.toggle('no-scroll', locked)
    return () => document.body.classList.remove('no-scroll')
  }, [locked])
}

export default useBodyScrollLock
